import {
    SERVICE_EMAIL_CONFIRMATION,
    SERVICE_EMAIL_CONFIRMATION_SUCCESS,
    SERVICE_EMAIL_CONFIRMATION_FAIL
  } from "./actionTypes";
  
  export const serviceEmailConfirmation = (token) => {
    return {
      type: SERVICE_EMAIL_CONFIRMATION,
      payload: { token },
    }
  }
  
  export const serviceEmailConfirmationSuccess = success => ({
    type: SERVICE_EMAIL_CONFIRMATION_SUCCESS,
    payload: success,
  })
  
  export const serviceEmailConfirmationFail = error => ({
    type: SERVICE_EMAIL_CONFIRMATION_FAIL,
    payload: error,
  })
